import * as React from 'react';
import { useCheckboxGroupOptions } from '../../internal';
import { CheckboxChipButton } from '../CheckboxChipButton';
import { ChipsGroup } from '../../../internal/components/Chip';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated использовать компонент Chips с пропсом selectType=multiple
 */
export const CheckboxChipsGroup = /*#__PURE__*/React.memo(function CheckboxChipsGroup(props) {
  const {
    value,
    disabled,
    invalid,
    name,
    role,
    inline,
    size,
    title,
    titleWeight,
    fullWidth,
    iconPosition,
    counterMaxLength,
    scrollable,
    defaultValue
  } = props;
  const options = useCheckboxGroupOptions(props);
  return /*#__PURE__*/_jsx(ChipsGroup, {
    title: title,
    size: size,
    titleWeight: titleWeight,
    role: role,
    inline: inline,
    fullWidth: fullWidth,
    scrollable: scrollable,
    children: options.map(_ref => {
      let {
        value: optionValue,
        label,
        onChange,
        icon,
        counter
      } = _ref;
      const key = String(optionValue);
      return /*#__PURE__*/_jsx(CheckboxChipButton, {
        name: name,
        value: key,
        checked: inList(optionValue, value),
        defaultChecked: defaultValue ? inList(optionValue, defaultValue) : undefined,
        disabled: disabled,
        invalid: invalid,
        label: label,
        onChange: onChange,
        role: role === 'listbox' ? 'option' : undefined,
        size: size,
        counterMaxLength: counterMaxLength,
        iconPosition: iconPosition,
        icon: icon,
        counter: counter,
        scrollInView: scrollable
      }, key);
    })
  });
});
function inList(item, list) {
  return !!(list !== null && list !== void 0 && list.some(value => value === item));
}